export default "__VITE_ASSET__BSMBIRBg__"